export default {
  title: 'Vorige drankjes',
  cocktail: 'cocktail',
  cocktails: 'cocktails',
};
